const erpConstants = {
  type: {
    create: 'CREATE',
    update: 'UPDATE',
    delete: 'DELETE',
    materialUpload: 'MATERIAL_UPLOAD',
  },
  deliveryPicklist: {
    secondary: 1,
    primary: 2,
    vendor: 3,
    returns: 4,
  },
  modifyPickList: {
    CHECK_WITHOUT_MATERIAL: 1,
    CHECK_MATERIAL: 2,
    MATERIAL_UPLOAD: 3,
  },
  flag: {
    CREATE: 1,
    UPDATE: 2,
    DELETE: 3,
  },
  ErpModule: {
    DELIVERY_PICKLIST: 'delivery_picklist_request',
    POD_FLOW: 'pod_flow_request',
    SHIPMENT_STATUS_UPDATE: 'shipment_status_update',
  },
  ERPResponseDateTimeFormat: 'YYYY/MM/DD HH:mm',
  ERPResponseDateFormat: 'YYYY/MM/DD',
  ERPResponseTimeFormat: 'HH:mm',
  validMaterialDeleteHeaders: {
    indent_no: 'indent_no',
    material_invoice_number: 'material_invoice_number',
    material_code: 'material_code',
    line_item_no: 'line_item_no',
  },
  ERP_ASSIGN_TRUCK_ERR_STATUS_REASON: 'Invalid order status because Indent is already Moved to #reason# Status',
  ERP_ASSIGN_TRUCK_ERR_VEHICLE_REASON: 'This Vehicle Number is already in used',
  ERP_ASSIGN_TRUCK_ERR_ORDER_REASON: 'Invalid order or shipment number',
  ZPOD_POSTING: 'EPOD',
};

module.exports = { erpConstants };
